import React from 'react';
import { MessageCircle, Check } from 'lucide-react';
const testimonials = [{
  name: 'Laura M.',
  time: '14:32',
  messages: ['Chicas os cuento, compré la guía de Hogar Blindado hace 2 semanas', 'Seguí los 3 pasos tal cual y NO HAN VUELTO 🙌', 'Mis hijas llevaban 4 meses con piojos, iba a la farmacia cada semana...', 'Por 6€ y pico ha sido lo mejor que he comprado']
}, {
  name: 'Ana R.',
  time: '16:45',
  messages: ['Yo también lo compré! El truco del spray para textiles es CLAVE', 'Nadie te dice que hay que tratar las sábanas y los cojines 😅', 'Llevamos 3 semanas limpias, mis niños felices']
}, {
  name: 'Carmen P.',
  time: '09:17',
  messages: ['Lo del calendario de 14 días es genial porque no se te olvida nada', 'Yo antes trataba el pelo y a la semana otra vez igual...', 'Ahora entiendo que el ciclo hay que cortarlo COMPLETO', 'Lo recomiendo 100% a todas las mamás del grupo 💪']
}];
export function SocialProofSection() {
  return <section className="py-16 bg-[#e8f4fc]/50" data-id="element-151">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-152">
        <div className="text-center mb-10" data-id="element-153">
          <h2 className="text-2xl md:text-3xl font-bold text-[#1e4d7b] mb-3" data-id="element-154">
            Lo que dicen madres que ya lo probaron
          </h2>
          <p className="text-gray-500 text-sm" data-id="element-155">
            Mensajes reales de nuestro grupo de apoyo
          </p>
        </div>

        <div className="space-y-4" data-id="element-156">
          {testimonials.map((testimonial, idx) => <div key={idx} className="bg-[#ECE5DD] rounded-xl p-4 shadow-sm" data-id="element-157">
              {/* WhatsApp-style header */}
              <div className="flex items-center gap-2 mb-3 pb-2 border-b border-[#d4cdc4]" data-id="element-158">
                <div className="w-8 h-8 rounded-full bg-[#4a90c2] flex items-center justify-center text-white text-xs font-bold" data-id="element-159">
                  {testimonial.name.charAt(0)}
                </div>
                <span className="font-semibold text-[#1e4d7b] text-sm" data-id="element-160">
                  {testimonial.name}
                </span>
                <MessageCircle className="h-3.5 w-3.5 text-[#25D366] ml-auto" data-id="element-161" />
              </div>

              {/* Messages */}
              <div className="space-y-1.5" data-id="element-162">
                {testimonial.messages.map((msg, msgIdx) => <div key={msgIdx} className="flex justify-start" data-id="element-163">
                    <div className="bg-white rounded-lg rounded-tl-none px-3 py-1.5 max-w-[85%] shadow-sm" data-id="element-164">
                      <p className="text-sm text-gray-800" data-id="element-165">{msg}</p>
                      <div className="flex items-center justify-end gap-1 mt-0.5" data-id="element-166">
                        <span className="text-[10px] text-gray-400" data-id="element-167">
                          {testimonial.time}
                        </span>
                        <Check className="h-3 w-3 text-[#53bdeb]" data-id="element-168" />
                        <Check className="h-3 w-3 text-[#53bdeb] -ml-1.5" data-id="element-169" />
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}